import { render, staticRenderFns } from "./AddNewProvider.vue?vue&type=template&id=78093178&"
import script from "./AddNewProvider.vue?vue&type=script&lang=js&"
export * from "./AddNewProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports